var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 2C-2.498 2.586 -2.502 29.412 16 30C34.498 29.414 34.502 2.588 16 2Z",
    fill: "#EB5757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.414 16L21.657 11.757C22.588 10.853 21.147 9.41199 20.243 10.343L16 14.586L11.757 10.343C10.853 9.41199 9.41199 10.853 10.343 11.757L14.586 16L10.343 20.243C9.41299 21.147 10.853 22.589 11.757 21.657L16 17.414L20.243 21.657C21.147 22.589 22.588 21.147 21.657 20.243L17.414 16Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/ErrorIcon.3d24492ce4787f47518a0c6d90ddd117.svg";
export { ForwardRef as ReactComponent };